<template>
  <div class="table">
    <tr>
      <td>Hard cash to close</td>
      <td class="has-text-right">{{ $store.state.evaluation.calculator.hardCashToClose | currency(0) }}</td>
    </tr>
    <tr>
      <td>Hard holding costs</td>
      <td class="has-text-right">{{ $store.state.evaluation.calculator.hardHoldingCost | currency(0) }}</td>
    </tr>
    <tr>
      <td>Refi cash to close</td>
      <td class="has-text-right">{{ $store.state.evaluation.calculator.hardRefiCashToClose | currency(0) }}</td>
    </tr>
    <tr>
      <td>
        *Refi cashback
      </td>
      <td class="has-text-right">{{ $store.state.evaluation.calculator.hardRefiCashBack | currency(0) }}</td>
    </tr>
    <tr>
      <td class="has-text-weight-semibold">TOTAL</td>
      <td class="has-text-right has-text-weight-semibold">{{ $store.state.evaluation.calculator.hardCashOutOfPocketTotal | currency(0) }}</td>
    </tr>
  </div>
</template>

<script>
import store from "@/store";

export default {
  components: {
    store
  }
};
</script>
